<ng-container cdkDrag cdkDragRootElement=".mat-mdc-dialog-container">
  <div mat-dialog-title cdkDragHandle></div>

  <mat-dialog-content [formGroup]="form">
    @if (show_non_owner_cannot_delete_warning() || show_non_owner_can_edit_instance_warning()) {
      <div class="non-owner-warning">
        <mat-icon>warning</mat-icon>
        @if (show_non_owner_cannot_delete_warning()) {
          <span> No puedes cambiar este evento. Para cambiarlo, pregunta a {{ owner_display_name() }} (propietario del evento). </span>
        } @else {
          <span>Hoy puedes editar solo esta instancia del evento porque {{ owner_display_name() }} no trabaja.</span>
        }
      </div>
    }

    <!-- start date and end date form -->
    <div class="row">
      <div class="col-12 col-lg-8">
        <mat-form-field appearance="outline" style="margin-top: 5px">
          <mat-label>Título personalizado</mat-label>
          <input matInput type="text" formControlName="custom_title" />
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4 d-flex align-items-center">
        <mat-checkbox formControlName="all_day">Todo el día</mat-checkbox>
      </div>
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline" class="w-100 nobottom" id="start-date">
          <mat-label>Fecha de inicio</mat-label>
          @if (form.controls['all_day'].value) {
            <input matInput [matDatepicker]="startDatetimePicker" [formControl]="start_date_ctrl" />
            <mat-datepicker-toggle matIconSuffix [for]="startDatetimePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatetimePicker></mat-datepicker>
          } @else {
            <input matInput [type]="'datetime-local'" [formControl]="start_date_ctrl" />
          }
          @if (form.controls['start'].invalid && form.controls['start'].errors?.['dateBeforeEnd']) {
            <mat-error>La fecha de inicio debe ser anterior a la fecha de fin</mat-error>
          }
          @if (form.controls['start'].invalid && form.controls['start'].errors?.['required']) {
            <mat-error>La fecha de inicio es obligatoria</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline" class="w-100 nobottom" id="end-date">
          <mat-label>Fecha final</mat-label>
          @if (form.controls['all_day'].value) {
            <input matInput [matDatepicker]="endDatetimePicker" formControlName="end" (focus)="onEndFocus()" />
            <mat-datepicker-toggle matIconSuffix [for]="endDatetimePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatetimePicker></mat-datepicker>
          } @else {
            <input matInput [type]="'datetime-local'" formControlName="end" (focus)="onEndFocus()" />
            <button
              mat-icon-button
              matIconSuffix
              [matMenuTriggerFor]="endDateMenu"
              [disabled]="form.controls['start'].value == null || form.controls['start'].value === ''"
            >
              <mat-icon>timer</mat-icon>
            </button>
            <mat-menu #endDateMenu="matMenu">
              <button mat-button (click)="addMinutes(5)">+5m</button>
              <button mat-button (click)="addMinutes(10)">+10m</button>
              <button mat-button (click)="addMinutes(30)">+30m</button>
              <button mat-button (click)="addMinutes(60)">+1h</button>
              <button mat-button (click)="addMinutes(90)">+1h 30m</button>
              <button mat-button (click)="addMinutes(120)">+2h</button>
              <button mat-button (click)="addMinutes(180)">+3h</button>
            </mat-menu>
          }
          @if (form.controls['end'].invalid && form.controls['end'].errors?.['dateAfterStart']) {
            <mat-error>La fecha de fin debe ser posterior a la fecha de inicio</mat-error>
          }
          @if (form.controls['end'].invalid && form.controls['end'].errors?.['required']) {
            <mat-error>La fecha de fin es obligatoria</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <mat-label>¿Es recurrente?</mat-label>
        <mat-form-field appearance="outline" class="nobottom">
          <mat-select
            [formControl]="recurrence_ctrl"
            [disabled]="form.controls['start'].value == null || form.controls['start'].value === ''"
            [matTooltip]="recurrence_ctrl.value === 'customized' && customRecurrenceText ? customRecurrenceText : ''"
          >
            <!-- No se repite -->
            <mat-option [value]="''">No se repite</mat-option>

            @if (customRecurrenceText) {
              <!-- Valor personalizado -->
              <mat-option [value]="'customized'">{{ customRecurrenceText }}</mat-option>
            }

            <!-- Cada dia -->
            <mat-option [value]="'daily'">Cada día</mat-option>

            <!-- Cada dia entre setmana -->
            <mat-option [value]="'laboralday'">Cada día entre semana</mat-option>

            <!-- Cada setmana el dimarts -->
            <mat-option [value]="'weekly'">Cada semana el {{ form.controls['start'].value | date: 'EEEE' }}</mat-option>

            <!-- Cada 2 semanas -->
            <mat-option [value]="'biweekly'">Cada 2 semanas</mat-option>

            <!-- Cada mes el 15 -->
            <mat-option [value]="'bymonthday'">Cada mes el día {{ form.controls['start'].value | date: 'dd' }}</mat-option>

            <!-- Cada mes el quart dimarts -->
            <mat-option [value]="'byweekno'"
              >Cada mes el {{ utils.getWeekNumberOfMonth(form.controls['start'].value) }}o
              {{ form.controls['start'].value | date: 'EEEE' }}</mat-option
            >

            <!-- Anualment el 24 de desembre -->
            <mat-option [value]="'byyearday'"
              >Cada año el {{ form.controls['start'].value | date: 'd' }} de {{ form.controls['start'].value | date: 'MMMM' }}</mat-option
            >

            <!-- Personalitza -->
            <mat-option [value]="'customize'"> Personaliza... </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-label>Categoría</mat-label>
        <mat-form-field appearance="outline" class="nobottom">
          <mat-select
            [formControlName]="is_company_product_category ? null : 'working_time_category_level_0'"
            (selectionChange)="onCategoryChange($event, 0)"
          >
            @for (wtc of working_time_categories; track wtc) {
              <mat-option [value]="wtc.id">
                {{ wtc.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if (is_company_product_category) {
      <div class="row">
        <div class="col-6">
          <mat-label>Producto</mat-label>
          <mat-form-field appearance="outline" class="nobottom">
            <input type="text" matInput [formControl]="companyProductControl" [matAutocomplete]="auto" placeholder="Buscar productos..." />
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="selectCompanyProduct($event.option.value)"
              [displayWith]="displayFnCompanyProduct"
            >
              @for (company_product of filtered_company_products; track company_product.id) {
                <mat-option [value]="company_product">{{ company_product.title }} </mat-option>
              }
            </mat-autocomplete>
            @if (updatable() && form.controls['company_product_id'].value !== '') {
              <button matSuffix mat-icon-button aria-label="Clear" (click)="resetCompanyProduct()">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
        @for (subcategory_select_level of subcategory_select_levels(); track subcategory_select_level.level) {
          <div class="col-6 mb-2">
            <mat-label>{{ subcategory_select_level.label }}</mat-label>
            <mat-form-field appearance="outline" class="nobottom">
              <mat-select
                [formControlName]="subcategory_select_level.form_control_name"
                (selectionChange)="onCategoryChange($event, subcategory_select_level.level)"
              >
                @for (category of subcategory_select_level.categories; track category.id) {
                  <mat-option [value]="category.id">
                    {{ category.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        @if (is_company_product_phase_category) {
          <div class="col-6 mb-2">
            <mat-label>Fase</mat-label>
            <mat-form-field appearance="outline" class="nobottom">
              <input
                type="text"
                matInput
                [formControl]="companyProductPhaseControl"
                [matAutocomplete]="auto"
                placeholder="Buscar fases..."
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="selectCompanyProductPhase($event.option.value)"
                [displayWith]="displayFnCompanyProductPhase"
              >
                @for (phase of filtered_company_product_phases; track phase.id) {
                  <mat-option [value]="phase">{{ phase.company_product_phase_type.name }} </mat-option>
                }
              </mat-autocomplete>
              @if (updatable() && form.controls['company_product_phase_id'].value !== '') {
                <button matSuffix mat-icon-button aria-label="Clear" (click)="resetCompanyProductPhase()">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }

    @if (shows_travel_time_checkbox) {
      <div class="row">
        <div class="col-12">
          <mat-checkbox [checked]="is_travel_time_checked" (change)="onTravelTimeToggle($event.checked)"
            >¿Es tiempo de desplazamiento?</mat-checkbox
          >
        </div>
      </div>
    }

    @if (should_show_location_selectors) {
      <div class="row">
        <div class="col-6">
          <mat-label>Ubicación de origen</mat-label>
          <mat-form-field appearance="outline" [class.nobottom]="!form.controls['origin_location_id'].errors">
            <mat-select
              formControlName="origin_location_id"
              panelWidth
              hideSingleSelectionIndicator
              [disabled]="should_disable_location_selectors()"
              (selectionChange)="onLocationSelectionChange('origin_location_id', $event.value)"
            >
              <mat-select-trigger>{{ locationName(form.value.origin_location_id) }}</mat-select-trigger>
              <mat-option [value]="CREATE_LOCATION_OPTION">
                <span class="location-option__create"><mat-icon>add</mat-icon>Crear ubicación</span>
              </mat-option>
              @for (location of locations(); track location.id) {
                <mat-option [value]="location.id">
                  <span class="location-option">
                    <span class="location-option__info">
                      <span class="location-option__name">{{ location.name }}</span>
                      <span class="location-option__type">{{ location.type_label }}</span>
                    </span>
                    <a
                      mat-icon-button
                      class="location-option__maps"
                      matTooltip="Ver ubicación"
                      (click)="openLocationDialog(location, $event)"
                    >
                      <mat-icon>location_on</mat-icon>
                    </a>
                  </span>
                </mat-option>
              }
            </mat-select>
            @if (form.controls['origin_location_id'].errors?.['locationSameAsOther']) {
              <mat-error>El origen y el destino no pueden ser iguales</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-label>Ubicación de destino</mat-label>
          <mat-form-field appearance="outline" [class.nobottom]="!form.controls['destination_location_id'].errors">
            <mat-select
              formControlName="destination_location_id"
              panelWidth
              hideSingleSelectionIndicator
              [disabled]="should_disable_location_selectors()"
              (selectionChange)="onLocationSelectionChange('destination_location_id', $event.value)"
            >
              <mat-select-trigger>{{ locationName(form.value.destination_location_id) }}</mat-select-trigger>
              <mat-option [value]="CREATE_LOCATION_OPTION">
                <span class="location-option__create"><mat-icon>add</mat-icon>Crear ubicación</span>
              </mat-option>
              @for (location of locations(); track location.id) {
                <mat-option [value]="location.id">
                  <span class="location-option">
                    <span class="location-option__info">
                      <span class="location-option__name">{{ location.name }}</span>
                      <span class="location-option__type">{{ location.type_label }}</span>
                    </span>
                    <a
                      mat-icon-button
                      class="location-option__maps"
                      matTooltip="Ver ubicación"
                      (click)="openLocationDialog(location, $event)"
                    >
                      <mat-icon>location_on</mat-icon>
                    </a>
                  </span>
                </mat-option>
              }
            </mat-select>
            @if (form.controls['destination_location_id'].errors?.['locationSameAsOther']) {
              <mat-error>El origen y el destino no pueden ser iguales</mat-error>
            }
          </mat-form-field>
        </div>
        @if (should_show_trip_distance_km()) {
          <p style="font-size: 12px; font-style: italic; margin: 0">Distancia del viaje: {{ trip_distance_km | number: '1.2-2' }} km</p>
        }
      </div>
    }

    <div class="row">
      <div class="col-12">
        <mat-label>Conferencia Online</mat-label>
      </div>
      <div class="col-12">
        <mat-form-field
          appearance="outline"
          style="width: auto"
          [ngClass]="{
            nobottom: form.controls['online_conference_type'].value !== '' && form.controls['online_conference_type'].value !== 'external',
          }"
        >
          <mat-label>Tipo de conferencia</mat-label>
          <mat-select formControlName="online_conference_type">
            <mat-option [value]="null">No hay conferencia online</mat-option>
            <mat-option [value]="'external'" [matTooltip]="'Por ejemplo creada manualmente por el cliente.'"
              >Conferencia externa</mat-option
            >
            <mat-option [value]="'teams'">Microsoft Teams</mat-option>
            <mat-option [value]="'meet'">Google Meet</mat-option>
            <mat-option [value]="'slack'" disabled>Slack</mat-option>
            <mat-option [value]="'zoom'" disabled>Zoom</mat-option>
          </mat-select>
        </mat-form-field>
        @if (form.controls['online_conference_type'].value !== '' && form.controls['online_conference_type'].value !== 'external') {
          @if (form.controls['call_link'].value != null && form.controls['call_link'].value !== '') {
            <p style="font-size: 12px; font-style: italic; margin: 0">
              Link de la reunión:
              <a [href]="form.controls['call_link'].value" target="_blank">{{ form.controls['call_link'].value }}</a>
              <button mat-icon-button><mat-icon>copy</mat-icon></button>
            </p>
          } @else {
            <p style="font-size: 12px; font-style: italic; margin: 0">Se creará una conferencia automáticamente al guardar.</p>
          }
        }
      </div>

      @if (form.controls['online_conference_type'].value === 'external') {
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Enlace de reunión</mat-label>
            <input matInput type="url" formControlName="call_link" placeholder="https://..." />
            @if (form.controls['call_link'].hasError('required')) {
              <mat-error>El enlace es obligatorio</mat-error>
            }
            @if (form.controls['call_link'].hasError('pattern')) {
              <mat-error>Formato de URL no válido</mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>

    @if (
      $safeNavigationMigration(this.event?.meta?.ecr?.trip_driver_user_id) !== null &&
      $safeNavigationMigration(this.event?.meta?.ecr?.trip_driver_user_id) !== undefined
    ) {
      <div class="row">
        <div class="col-12">
          <mat-label>Conductor</mat-label>
        </div>
        <div class="col-12">
          <mat-form-field appearance="outline" class="nobottom" style="width: auto">
            <input
              matInput
              type="text"
              [value]="
                $safeNavigationMigration(this.event?.meta?.ecr?.trip_driver_user_name) +
                ' ' +
                $safeNavigationMigration(this.event?.meta?.ecr?.trip_driver_user_surnames)
              "
              [disabled]="true"
            />
          </mat-form-field>
        </div>
      </div>
    }

    <div class="row">
      <div class="col-12">
        <mat-label>Compartir evento</mat-label>
      </div>
      <div class="col-12">
        <mat-checkbox [formControl]="team_event_ctrl">Evento para todos los empleados</mat-checkbox>
      </div>
      @if (form.controls['user_id'].value != null) {
        <div class="col-12">
          <mat-form-field appearance="outline" style="margin-bottom: 20px">
            <mat-label>Compartir evento con:</mat-label>
            <mat-chip-grid #sharedUserChipGrid [disabled]="!updatable()">
              @for (
                shared_user of form.controls['employee_calendar_register_user_shared_events'].value;
                track shared_user;
                let i = $index
              ) {
                <mat-chip-row (removed)="removeSharedUser(i)" [id]="'chip-' + i" [disabled]="!updatable()">
                  {{ getAnonymousUserDisplayName(shared_user) }}
                  @if (updatable()) {
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
            <input
              #userSearchCtrlInput
              [formControl]="user_search_ctrl"
              [matChipInputFor]="sharedUserChipGrid"
              [matAutocomplete]="auto"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="onSharedUserInputTokenEnd($event)"
            />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectedOptionAutocompleteForSharedUser($event)">
              @for (user of filtered_users_to_share; track user) {
                <mat-option [value]="user">{{ user.name + ' ' + user.surnames + ' (' + user.email + ')' }}</mat-option>
              }
            </mat-autocomplete>
            <mat-hint
              >Puedes introducir el nombre de un usuario o un correo electrónico.
              @if (form.controls['user_id'].value != null && form.controls['user_id'].value != me.id && event?.meta?.ecr) {
                Este evento ha sido creado por
                <b>{{ event?.meta?.ecr?.user_name ?? 'Desconocido' }} {{ event?.meta?.ecr?.user_surnames ?? '' }}</b
                >.
              }
            </mat-hint>
          </mat-form-field>
        </div>
      }
    </div>

    <div class="row">
      <div class="col-12">
        <mat-label>Otras opciones configurables</mat-label>
      </div>
      <div class="col-12">
        <mat-checkbox formControlName="is_blocked_for_meetings">Tu calendario aparecerá bloqueado en esta franja horaria.</mat-checkbox>
      </div>
      <div class="col-12">
        <mat-checkbox formControlName="meet_mode">Activar modo reunión automáticamente</mat-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-label>Descripción del evento</mat-label>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" class="nobottom">
          <textarea matInput rows="5" formControlName="description"></textarea>
        </mat-form-field>
      </div>
    </div>

    <!-- Notifications Section -->
    <div class="row" style="margin-top: 20px">
      <div class="col-12">
        <div style="display: flex; align-items: center; margin-bottom: 10px">
          <mat-icon style="margin-right: 8px">notifications</mat-icon>
          <mat-label style="font-weight: 500">Notificaciones</mat-label>
        </div>
        @if (loadingNotifications) {
          <p>Cargando notificaciones...</p>
        } @else {
          @if (notifications.length === 0) {
            <p style="color: #666; font-size: 14px; margin-bottom: 10px">No hay notificaciones configuradas</p>
          } @else {
            <div style="margin-bottom: 10px">
              @for (notification of notifications; track notification.id || $index) {
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 8px;
                    margin-bottom: 8px;
                    background-color: #f5f5f5;
                    border-radius: 4px;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 12px">
                    <mat-icon>{{ getChannelIcon(notification.channels[0]) }}</mat-icon>
                    <div>
                      <div style="font-weight: 500">
                        @if (notification.minutes_before === 0) {
                          En el momento del evento
                        } @else {
                          {{ notification.minutes_before }} minutos antes
                        }
                      </div>
                      <div style="font-size: 12px; color: #666">
                        {{ notification.channels | channelsLabel }}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; gap: 4px">
                    <button mat-icon-button (click)="openNotificationDialog(notification)" [disabled]="data.user_id !== me.id">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button (click)="deleteNotification(notification)" [disabled]="data.user_id !== me.id">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
          <button mat-stroked-button (click)="openNotificationDialog()" [disabled]="data.user_id !== me.id" style="width: 100%">
            <mat-icon style="margin-right: 8px">add</mat-icon>
            Añadir una notificación
          </button>
        }
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button cdkFocusInitial (click)="close()">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
    <button mat-flat-button color="accent" (click)="save()" [disabled]="!canSave">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
    @if (is_persisted_event()) {
      <button mat-icon-button type="button" [matMenuTriggerFor]="eventActionsMenu" aria-label="Más acciones">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #eventActionsMenu="matMenu">
        @if (form.controls['call_link'].value) {
          <a mat-menu-item [href]="form.controls['call_link'].value" target="_blank" rel="noopener noreferrer">
            <mat-icon>videocam</mat-icon>
            <span>Abrir reunión</span>
          </a>
        }
        <button
          mat-menu-item
          type="button"
          [disabled]="!can_edit()"
          [style.color]="can_edit() ? 'var(--red)' : null"
          (click)="deleteEvent()"
        >
          <mat-icon [style.color]="can_edit() ? 'var(--red)' : null">delete</mat-icon>
          <span>Eliminar evento</span>
        </button>
      </mat-menu>
    }
  </mat-dialog-actions>
</ng-container>
